import React from "react";
import { Button } from "primereact/button";
import { Link, useNavigate, useLocation } from "react-router-dom";

const AccessDeniedPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/";

  const handleBack = () => {
    navigate(from);
  };

  return (
    <div className="surface-ground flex align-items-center justify-content-center min-h-screen p-3">
      <div className="flex flex-column align-items-center justify-content-center w-full" style={{ maxWidth: "520px" }}>
        <Link to="/app/homepage" className="flex align-items-center">
          <img src="/images/logoosbuk.png" alt="OSBÜK Logo" className="mb-4" height="52" />
        </Link>
        <div className="w-full surface-card border-1 surface-border border-round-2xl shadow-3 py-5 px-4 sm:px-6 flex flex-column align-items-center text-center">
          <div
            className="flex justify-content-center align-items-center bg-orange-500 border-circle mb-3"
            style={{ height: "3.5rem", width: "3.5rem" }}
          >
            <i className="pi pi-fw pi-lock text-2xl text-white"></i>
          </div>
          <h1 className="text-900 font-bold text-2xl sm:text-3xl mb-2">Erişim Engellendi</h1>
          <p className="text-600 text-sm mb-4">
            Bu sayfaya erişim yetkiniz bulunmamaktadır. Lütfen yetkili bir hesap ile giriş yapınız.
          </p>
          <div className="flex flex-wrap gap-2 justify-content-center w-full mt-2">
            <Button icon="pi pi-arrow-left" label="Geri Dön" outlined onClick={handleBack} className="flex-1" />
            <Button icon="pi pi-home" label="Ana Sayfaya Git" onClick={() => navigate("/")} className="flex-1" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccessDeniedPage;
